import { render, staticRenderFns } from "./MediaVideoExcerpt.vue?vue&type=template&id=76e33961&scoped=true"
import script from "./MediaVideoExcerpt.vue?vue&type=script&lang=js"
export * from "./MediaVideoExcerpt.vue?vue&type=script&lang=js"
import style0 from "./MediaVideoExcerpt.vue?vue&type=style&index=0&id=76e33961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e33961",
  null
  
)

export default component.exports